import React from "react";
import { useAppSelector } from "../../../hooks/useAppSelector";
import DropdownMenu from "./DropDownMenu";

interface ProfileProps {
  setActiveComponent: (component: string) => void;
}

const Profile: React.FC<ProfileProps> = ({ setActiveComponent }) => {
  const { fullname, email } = useAppSelector((state) => state.user);

  return (
    <div className="mt-1 flex items-center space-x-2">
      <DropdownMenu
        setActiveComponent={setActiveComponent}
        email={email}
        fullname={fullname}
      />
    </div>
  );
};

export default Profile;
